/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { contract_id } from '../models/contract_id';
import type { ContractForList } from '../models/ContractForList';
import type { ContractForNew } from '../models/ContractForNew';
import type { ContractForUpdate } from '../models/ContractForUpdate';
import type { ContractListParams } from '../models/ContractListParams';
import type { ContractListResponse } from '../models/ContractListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ContractsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a new Contract
     * Creates a new Contract. (Access: admin)
     * @returns any Unexpected error
     * @returns ContractForUpdate Contract created. The URI of the new resource is included in the Location header of the response.
     * @throws ApiError
     */
    public createContract({
        requestBody,
    }: {
        /**
         * Contract's information
         */
        requestBody: ContractForNew,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | ContractForUpdate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/contracts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get a list of Contracts
     * Get a list of Contracts. (Access: admin)
     * @returns ContractListResponse Contracts list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getContracts({
        requestBody,
    }: {
        /**
         * Contract's information
         */
        requestBody: ContractListParams,
    }): CancelablePromise<ContractListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/contracts/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a Contract
     * Returns a Contract based on a single ID (Access: admin)
     * @returns ContractForList Contract's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getContractById({
        id,
    }: {
        /**
         * ID of the Contract to fetch
         */
        id: contract_id,
    }): CancelablePromise<ContractForList | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a Contract
     * Update a Contract. (Access: admin)
     * @returns ContractForUpdate Contract updated.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateContract({
        id,
        requestBody,
    }: {
        /**
         * ID of the Contract to update
         */
        id: contract_id,
        /**
         * Contract's information
         */
        requestBody: ContractForUpdate,
    }): CancelablePromise<ContractForUpdate | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/contracts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete a contract
     * Deletes a single Contract based on the ID supplied. (Access: admin)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteContractById({
        id,
    }: {
        /**
         * ID of the Contract to delete
         */
        id: contract_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
